import React, { forwardRef } from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  className,
  label,
  error,
  helperText,
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-462">
        {label && <label className="block text-sm font-medium text-navy mb-1.5" data-id="element-463">
            {label} {props.required && <span className="text-red-500" data-id="element-464">*</span>}
          </label>}
        <input className={cn('flex h-11 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50', error && 'border-red-500 focus-visible:ring-red-500', className)} ref={ref} {...props} data-id="element-465" />
        {helperText && !error && <p className="mt-1 text-xs text-gray-500" data-id="element-466">{helperText}</p>}
        {error && <p className="mt-1 text-xs text-red-500" data-id="element-467">{error}</p>}
      </div>;
});
Input.displayName = 'Input';